import axios from "@/api/axios";
import qs from "qs";

const get_roomlist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    roomlistcnt: null,
    roomlist: [
      {
        roomnum: null,
        roomname: null,
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/booking/roomlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(response.data);
    }
  });
};

const bookingList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    // 'roomsno': 1,
    // 'roomeno': 5,
    bookinglistcnt: "0",
    bookinglist: [
      {
        no: 0,
        roomno: null,
        starttime: null,
        endtime: null,
        memo: null,
        bookingno: null,
      },
    ],
  };
  // console.log(params)
  const options = {
    method: "GET",
    url: "/booking/bookinglist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: params,
    // params: { 'searchdate': params.searchdate, 'pageno': params.pageno, 'roomsno': params.roomeno, 'roomsno': params.roomeno, 'pagesize': params.pagesize }
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const bookingInsert = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/booking/bookingwrite",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(params),
    // params: {o}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const bookingModify = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/booking/bookingwrite/" + params.bookingno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(params),
    // params: {}
  };
  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, null);
    }
  });
};

const bookingDelete = async (bookingno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "DELETE",
    url: "/postact//bookingdelete/" + bookingno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify()
  };
  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, null);
    }
  });
};
export default {
  get_roomlist,
  bookingList,
  bookingInsert,
  bookingModify,
  bookingDelete,
};
